import { KeyValue } from './types/KeyValue';

// 棚種別
export const shelf_type = {
  header: 1,
  shelf: 2,
  layout_divisiton: 3,
  fragment: 4,
  footer: 5,
  full_justify_buttons: 6,
  left_button: 7,
  center_button: 8,
  right_button: 9,
  justify_buttons: 10,
  staff_reception_action_buttons: 11,
  documents: 21,
  guarantor_1: 31, // 連帯債務者・保証人1
  guarantor_2: 32, // 連帯債務者・保証人2
  guarantor_3: 33, // 連帯債務者・保証人3
  guarantor_4: 34, // 連帯債務者・保証人4
  guarantor_5: 35, // 連帯債務者・保証人5
  guarantor_6: 36, // 連帯債務者・保証人6
  guarantor_7: 37, // 連帯債務者・保証人7
  guarantor_8: 38, // 連帯債務者・保証人8
  guarantor_9: 39, // 連帯債務者・保証人9
  guarantor_10: 40, // 連帯債務者・保証人10
  guarantor_11: 41, // 連帯債務者・保証人11
  guarantor_12: 42, // 連帯債務者・保証人12
  guarantor_13: 43, // 連帯債務者・保証人13
  guarantor_14: 44, // 連帯債務者・保証人14
  guarantor_15: 45, // 連帯債務者・保証人15
  guarantor_16: 46, // 連帯債務者・保証人16
  guarantor_17: 47, // 連帯債務者・保証人17
  guarantor_18: 48, // 連帯債務者・保証人18
  guarantor_19: 49, // 連帯債務者・保証人19
  guarantor_20: 50, // 連帯債務者・保証人20
  mypage_return: 101, // マイページへ戻る
  footer_reception_detail_staff: 102, // 案件詳細（職員）
  footer_pre_examination_result_confirmation: 103, // KWANKGM03040_事前審査結果確認
  footer_pre_examination_application_input_confirmation: 104, // KWANKGM03020_事前審査申込入力（確認）
  footer_pre_examination_application_input_complete: 105, // KWANKGM03030_事前審査申込入力（受付完了）
  footer_pre_examination_application_input_detail: 106, // KWANKGM03010_事前審査申込入力詳細
  footer_confirmation_borrowing_consultation_results: 107, // KWANKGM02040_借入相談結果確認フッタボタン
  footer_borrowing_consultation_input: 108, // KWANKGM02010_借入相談入力
  footer_borrowing_consultation_input_confirmation: 109, // KWANKGM02020_借入相談入力確認
  footer_agri_fund_loan_application_details: 110, // KWANKGM04100_農業資金借入申込詳細
  footer_pre_examination_result_input_staff: 111, // KWANKGM11020_事前審査結果入力（承認・不承認）（職員）
  footer_borrowing_application_input_confirmation: 112, // KWANKGM04030_借入申込入力（確認）, KWANKGM04120_農業資金借入申込入力（確認）
  footer_confirmation_of_main_examination_results: 113, // KWANKGM04070_本審査結果確認, KWANKGM04140_農業資金本審査結果確認
  footer_borrowing_application_details: 114, // KWANKGM04010_借入申込詳細
  footer_borrowing_application_details_inquiry: 115, // KWANKGM04050_借入申込内容照会（連帯債務者等）, KWANKGM04130_農業資金借入申込内容照会（連帯債務者等）
  footer_confirmation_of_contract_contents: 116, // KDANKGM05010_契約書内容確認, KDANKGM05040_農業資金契約書内容確認
  footer_contract_application_confirmation: 117, // KWANKGM04080_契約申込確認
  footer_pre_examination_project_details: 118, // KWANKGM11010_事前審査案件詳細（職員）
};

// 案件種別ID
export const reception_type = {
  borrowing_consultation: '1', // 借入相談
  preliminary_review: '2', // 事前審査
  final_review: '3', // 本審査
};

// JA、信連、農林中金の区別
export const organization_type = {
  nourin: '01',
  shinren: '02',
  ja: '03',
};

// 同意文の種別
/**
 * @heading 画面最上部の見出し
 * @types 同意文言種別
 * @main_btn_label 画面下部中央のボタンラベル
 * @sub_btn_label 画面左下のボタンラベル
 * @sub_btn_area 画面左下にボタンを配置かテキストを表示させる
 * @leave_text ボタンを表示しないときの文言
 */
export const clauses_list = [
  {
    // マイページ開設同意確認
    heading: 'マイページ開設同意確認',
    types: [1],
    main_btn_label: '同意してマイページ開設へ進む',
    sub_btn_label: '戻る',
    sub_btn_area: undefined,
    leave_text: '処理を中断する場合は本ページを閉じて下さい。',
  },
  {
    // マイページ開設・個人情報取り扱い等同意確認
    heading: 'マイページ開設・個人情報取り扱い等同意確認',
    types: [1, 2, 3],
    main_btn_label: '同意する',
    sub_btn_label: '同意しない',
    sub_btn_area: undefined,
    leave_text: '',
  },
  {
    // 個人情報取扱等同意確認
    heading: '',
    types: [2, 3],
    main_btn_label: '',
    sub_btn_label: '戻る',
    sub_btn_area: undefined,
    leave_text: '処理を中断する場合は本ページを閉じて下さい。',
  },
];
// 同意ポップアップのヘッダ種類
export const agreement_label: { [key: number]: string } = {
  1: 'マイページ開設同意確認',
  2: 'お借入の申込、保証委託の申込ならびに個人情報の取扱いに関する同意文書',
  3: '反社会的勢力ではないことの表明・確約に関する同意文書',
};

// True,False
export const checked_on = true;
export const checked_off = false;

// 商品選択画面のパス
export const product_image_path = `${process.env.MIX_MOCK_FILEURL}/img/product_list/`;
// 商品選択画面の画像パス
export const overview_step_img = `${process.env.MIX_MOCK_FILEURL}/img/product_list/overview_step.png`;
export const ahead_step_img = `${process.env.MIX_MOCK_FILEURL}/img/product_list/ahead_step.png`;
export const main_step_img = `${process.env.MIX_MOCK_FILEURL}/img/product_list/main_step.png`;
export const contract_step = `${process.env.MIX_MOCK_FILEURL}/img/product_list/contract_step.png`;
export const contract_step_icon = `${process.env.MIX_MOCK_FILEURL}/img/product_list/contract_step_icon.png`;
export const file_icon = `${process.env.MIX_MOCK_FILEURL}/img/product_list/file_icon.png`;

// 一時変数の初期値
export const tmp_init = {
  key: '',
  pb_id: 0,
  cb_id: 0,
  fm_id: 0,
  fm_display_name: '',
  required_mark: false,
  field_column_name: '',
  fm_type: '',
  placeholder: '',
  function: '',
  message: '',
  value: '',
  prefix: '',
  suffix: '',
  sources: [{ key: '', value: '', checked: false }],
  help_msg: '',
  disabled: false,
  bold: false,
  color: '',
  dialog: false,
  dialog_title: '',
  dialog_msg: '',
  dialog_is_open: false,
  input_assistance: '',
  maxlength: 0,
  readonly: false,
};

// 応答ダイアログの初期値
export const dialog_init = {
  is_confirm: false,
  show: false,
  title: '',
  body: '',
};

// 応答ダイアログの種別
export const dialog_type = {
  confirm: '1',
  yes_no: '2',
};

// 応答ダイアログのファンクション位置
export const dialog_function = {
  confirm: 0,
  yes: 1,
  no: 2,
};

// pdfのアイコン
export const pdf_icon = `${process.env.MIX_MOCK_URL}/images/pdf_icon.png`;

// APIからの応答種別
export const api_response_type = {
  page_transition: 0, // 画面遷移
  dialog: 1, // ダイアログ
  validation: 2, // バリデーション
  list: 3, // リスト
  auto_input: 4, // 指定項目の自動表示
  transition_to_list: 9, // 一覧画面に遷移
  online_identification: 10, // オンライン本人確認_成功
  download: 11, // pdfダウンロード
  transition_to_mypage_complete: 12, // マイページ開設完了画面への遷移
  navigation_finish: 24, // それぞれの申込完了画面に遷移
  transition_to_borrowing_application: 27, // 借入申込詳細画面へ遷移
  transition_to_mypage: 28, // マイページ開設同意確認画面への遷移
  transition_to_agriculture_borrowing_application: 29, // 農業資金借入申込詳細画面へ遷移
  temporarily_saved: 30, // 一時保存完了
  transition_to_corporate_entry_confirm: 31, // 法人情報編集（確認）画面に遷移
  transition_to_corporate_info_detail: 32, // 法人情報詳細画面に遷移
  transition_to_contract_signature: 36, // 契約書署名画面へ遷移
  signature_resend_complete: 37, // 電子署名ID・KEY再送完了
  transition_to_pre_examination_input_housing_loan_firmly: 38, // 住宅ローンしっかり審査事前審査申込入力詳細へ遷移
  modernization_fund_init_reg_complete: 39, // 入力種別選択画面へ遷移
  transition_to_borrowing_consultation_updating: 40, // 借入相談入力画面へ遷移
  transition_to_borrowing_consultation_changing: 41, // 借入相談入力(変更)画面へ遷移
  modernization_funds_application_category_temporarily_saved: 42, //「申込区分」の値でテンプレート切り替え時の一時保存成功時
  transition_to_ekyc_error: 98, // eKYCエラー画面へ遷移
  error: 99, // システムエラー、相関チェックエラー
};

// 法人情報の承認ステータス
export const approval_status = {
  unapproved: 1000, // 未承認
  approved: 2000, // 承認
  send_back: 3000, // 差戻し
};

/**
 * 値変換種別
 */
export const convert_types = {
  add_comma: 'addComma',
  change_numeric: 'cngNumeric',
  change_zenkaku_kana: 'cngZenkakuKana',
  change_hankaku_kana: 'cngHankakuKana',
  add_decimal_point: 'addDecimalPoint',
  change_zenkaku: 'cngZenkaku',
  change_account_holder_zenkakuKana: 'cngAccountHolderZenkakuKana',
  change_numeric_hyphen: 'cngNumericHyphen',
  allow_minus: 'allowMinus',
};

/**
 * フィールドマスタのタイプ
 */
export const fm_types = {
  text: 'TEXT',
  number: 'NUMBER',
  year: 'YEAR',
  month: 'MONTH',
  pincode: 'PINCODE',
  date: 'DATE',
  button: 'BUTTON',
  postcode: 'POSTCODE',
  telnumber: 'TELNUMBER',
  sei: 'SEI',
  mei: 'MEI',
  radio: 'RADIO',
  deselect_radio: 'DESELECT_RADIO',
  checkbox: 'CHECKBOX',
  select: 'SELECT',
  relevant_plan_select: 'RELEVANT_PLAN_SELECT',
  textarea: 'TEXTAREA',
  paragraph: 'PARAGRAPH',
  paragraph2: 'PARAGRAPH2',
  link: 'LINK',
  image: 'IMAGE',
  items: 'ITEMS',
  business_date: 'BUSINESSDATE',
  after_specified_date: 'AFTERSPECIFIEDDATE',
  year_month: 'YEAR_MONTH',
  date_year_month: 'DATE_YEAR_MONTH',
  jacode: 'JACODE',
  desired_trading_store_jacode: 'DESIRED_TRADING_STORE_JACODE',
  janame: 'JANAME',
  office: 'OFFICE',
  name: 'NAME',
  sei_name: 'SEI_NAME',
  increase_months_select: 'INCREASE_MONTHS_SELECT',
  time: 'TIME',
  guidetext: 'GUIDETEXT',
  application_information: 'APPLICATION_INFORMATION',
  heading_m: 'HEADING_M',
  guarantor_num: 'GUARANTORNUM',
  refinance_target_checkbox: 'REFINANCE_TARGET_CHECKBOX',
  skip_link: 'SKIPLINK',
  guidetext_show_active: 'GUIDETEXT_SHOW_ACTIVE',
  office_code: 'OFFICE_CODE',
  agreement: 'AGREEMENT',
  blank: 'BLANK',
  agreement_checkbox: 'AGREEMENT_CHECKBOX',
  modernization_funds_application_category: 'MODERNIZATION_FUNDS_APPLICATION_CATEGORY',
  guarantornum_select: 'GUARANTORNUM_SELECT',
  online_identification: 'ONLINE_IDENTIFICATION',
  online_identification_guarantor: 'ONLINE_IDENTIFICATION_GUARANTOR',
  owner_collateral_provider_name_check: 'OWNER_COLLATERAL_PROVIDER_NAME_CHECK',
  guarantor_num_linked_checkbox: 'GUARANTOR_NUM_LINKED_CHECKBOX',
  radio_desired_econtract: 'RADIO_DESIRED_ECONTRACT',
  single_checkbox: 'SINGLE_CHECKBOX',
  desired_trading_office: 'DESIRED_TRADING_OFFICE',
  desired_trading_office_code: 'DESIRED_TRADING_OFFICE_CODE',
};

/**
 * UTF文字コード（UTF-16 BE）
 */
export const utf_code = {
  zenkaku_numeric_start: 0xff10, // 全角数字の始点文字コード
  zenkaku_numeric_end: 0xff19, // 全角数字の終点文字コード
  zenkaku_numeric_convert: 0xfee0, // 全角数字→半角数字の変換用文字コード
  zenkaku_hiragana_start: 0x3041, // 全角ひらがなの始点文字コード
  zenkaku_hiragana_end: 0x3093, // 全角ひらがなの終点文字コード
  zenkaku_hiragana_convert: 0x0060, // 全角ひらがなの変換用文字コード
  hankaku_dakuten: 0xff9e, // 半角ｶﾅの濁点の文字コード
  hankaku_handakuten: 0xff9f, // 半角ｶﾅの半濁点の文字コード
};

/**
 * ダウンロード対象のファイル種別
 */
export const content_type = {
  pdf: 'pdf',
  app_pdf: 'application/pdf',
  csv: 'text/csv',
};
/**
 * 変換文字
 */
export const convert_char = {
  hankaku_kana: '｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝ ',
  hankaku_kana_dakuon_base: 'ｳｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾊﾋﾌﾍﾎ',
  hankaku_kana_handakuon_base: 'ﾊﾋﾌﾍﾎ',
  hankaku_kana_dakuten: 'ﾞ',
  hankaku_kana_handakuten: 'ﾟ',
  zenkaku_kana:
    '。「」、・ヲァィゥェォャュョッーアイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワン　',
  zenkaku_kana_dakuon: 'ヴガギグゲゴザジズゼゾダヂヅデドバビブベボ',
  zenkaku_kana_handakuon: 'パピプペポ',
  zenkaku_hiragana:
    '。「」、・をぁぃぅぇぉゃゅょっーあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわん　',
  zenkaku_hiragana_dakuon: 'ゔがぎぐげござじずぜぞだぢづでどばびぶべぼ',
  zenkaku_hiragana_handakuon: 'ぱぴぷぺぽ',
  hankaku_space: ' ',
  zenkaku_space: '　',
  hankaku_backslash: /\\/g,
  zenkaku_backslash: '￥',
  zenkaku_numeric_base: '１２３４５６７８９０',
  hankaku_numeric_base: '1234567890',
  zenkaku_alphabet_base:
    'ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚＡＢＣＤＥＦＧＨＩＪＫＭＬＮＯＰＱＲＳＴＵＶＷＸＹＺ',
  hankaku_alphabet_base: 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKMLNOPQRSTUVWXYZ',
};

/**
 * HTTPステータスコード
 */
export const http_status = {
  ok: 200,
  created: 201,
};

/**
 * バリデーション用の結合文字列
 * Note : ボタン押下時のバリデーション対象がcheckboxだった場合に使用
 */
export const merge_index = '-0';

/**
 * バリデーション用の結合文字列
 * Note : ボタン押下時のバリデーション対象がpostcode、nameだった場合に使用
 */
export const merge_last = '_last';

/**
 * バリデーション用の結合文字列
 * Note : ボタン押下時のバリデーション対象がyear_month、timeだった場合に使用
 */
export const merge_year = '-year';

/**
 * スクロール位置調整用オプション
 */
export const scroll_option = {
  validation: -60,
  validation_checkbox: -200,
};

/*
 * pdfダウンロード時のwaitタイム(ミリ秒)
 */
export const download_wait_time = 3000;

/**
 * Note sakuma
 * ここより下の部分はモック用の固定値になります。
 * 本実装に関わる記述を記載しないでください。
 */

import { FileUpload } from './types/FileUpload';

export const test_person = [
  { type: '1', key: '0', value: '' },
  { type: '1', key: '1', value: '免許証' },
  { type: '1', key: '2', value: '保険証' },
  { type: '1', key: '3', value: '住民票' },
];
export const test_certification = [
  { type: '2', key: '0', value: '' },
  { type: '2', key: '1', value: '証明A' },
  { type: '2', key: '2', value: '証明B' },
  { type: '2', key: '3', value: '証明C' },
];
export const test_document = [
  { type: '3', key: '0', value: '' },
  { type: '3', key: '1', value: '収集同意書' },
  { type: '3', key: '2', value: '保有同意書' },
  { type: '3', key: '3', value: '利用同意書' },
  { type: '3', key: '4', value: '提供同意書' },
];

// ファイルアップロード, バリデーション初期状態
export const valid_init_state = {};

// ファイルアップロード_初期ステータス（申込人）
export const person_initialState: FileUpload[] = [
  {
    name: 0,
    title: '本人確認資料',
    default_value: '1',
    shelf_cd: 'A',
    source: test_person,
    preview_file_src: '',
    file_label: '',
    is_loading: false,
    loading_msg: '',
    is_add: true,
    is_staff: true,
    is_uploaded: false,
    file_upload_date: '2021/01/08',
    confirm_date: '',
    confirm_user: '',
    file: new Blob(),
    valid_messages: valid_init_state,
    is_modal_show: false,
    file_upload_name: '',
    file_status: '',
    is_pdf: false,
  },
];
export const certification_initialState: FileUpload[] = [
  {
    name: 1,
    title: '所得証明',
    default_value: '2',
    shelf_cd: 'B',
    source: test_certification,
    preview_file_src: '',
    file_label: '',
    is_loading: false,
    loading_msg: '',
    is_add: true,
    is_staff: true,
    is_uploaded: false,
    file_upload_date: '2021/01/08',
    confirm_date: '',
    confirm_user: '',
    file: new Blob(),
    valid_messages: valid_init_state,
    is_modal_show: false,
    file_upload_name: '',
    file_status: '',
    is_pdf: false,
  },
];
export const document_initialState: FileUpload[] = [
  {
    name: 2,
    title: '物件資料',
    default_value: '3',
    shelf_cd: 'B',
    source: test_document,
    preview_file_src: '',
    file_label: '',
    is_loading: false,
    loading_msg: '',
    is_add: true,
    is_staff: false,
    is_uploaded: false,
    file_upload_date: '2021/01/08',
    confirm_date: '',
    confirm_user: '',
    file: new Blob(),
    valid_messages: valid_init_state,
    is_modal_show: false,
    file_upload_name: '',
    file_status: '',
    is_pdf: false,
  },
];

// ファイルアップロード_初期ステータス（職員）
export const person_initialState_staff: FileUpload[] = [
  {
    name: 3,
    title: '本人確認資料',
    default_value: '0',
    shelf_cd: 'C',
    source: test_person,
    preview_file_src: '',
    file_label: '',
    is_loading: false,
    loading_msg: '',
    is_add: true,
    is_staff: true,
    is_uploaded: false,
    file_upload_date: '',
    confirm_date: '',
    confirm_user: '',
    file: new Blob(),
    valid_messages: valid_init_state,
    is_modal_show: false,
    file_upload_name: '',
    file_status: '',
    is_pdf: false,
  },
];
export const certification_initialState_staff: FileUpload[] = [
  {
    name: 4,
    title: '所得証明',
    default_value: '0',
    shelf_cd: 'D',
    source: test_certification,
    preview_file_src: '',
    file_label: '',
    is_loading: false,
    loading_msg: '',
    is_add: true,
    is_staff: true,
    is_uploaded: false,
    file_upload_date: '',
    confirm_date: '',
    confirm_user: '',
    file: new Blob(),
    valid_messages: valid_init_state,
    is_modal_show: false,
    file_upload_name: '',
    file_status: '',
    is_pdf: false,
  },
];
export const document_initialState_staff: FileUpload[] = [
  {
    name: 5,
    title: '物件資料',
    default_value: '0',
    shelf_cd: 'I',
    source: test_document,
    preview_file_src: '',
    file_label: '',
    is_loading: false,
    loading_msg: '',
    is_add: true,
    is_staff: true,
    is_uploaded: false,
    file_upload_date: '',
    confirm_date: '',
    confirm_user: '',
    file: new Blob(),
    valid_messages: valid_init_state,
    is_modal_show: false,
    file_upload_name: '',
    file_status: '',
    is_pdf: false,
  },
];

export const email_domain = 'xxxxxxx.com';

// 本人確認書類の画像イメージの設定
export const compressor_option = {
  quality: 1,
  max_height: 1920,
  max_width: 1080,
  preview_max_height: 300,
  preview_max_width: 300,
};

// 本人確認書類のプレビュー画像イメージの設定
export const preview_option = {
  reduction_rate_pc: 0.7,
  reduction_rate_sp: 0.7,
};

export const file_type_error = {
  file: ['ファイルにはpdf,bmp,jpeg,jpg,png,gifタイプのファイルを指定して下さい。'],
};

export const file_upload_error = {
  file: ['ファイルアップロードに失敗しました'],
};

// ファイルアップロード　ラベルの省略設定
export const file_upload_clamp_config = {
  length: 18,
  clamp_string: '...',
};

//入力支援(桁埋め)の追加文字列
export const assist_digit = '0000000000';

//テキストエリアのデフォルト行数
export const textarea_default_row = 3;

//案件一覧 検索パラメータの初期値
export const search_params_init = {
  store_in_charge: '', // 担当店舗
  application_no: '', // 申込No
  name: '', // 名前(漢字)
  account_no: '', // 口座番号
  loan_type: '', // ローン種類
  reception_date: null, // 受付日
  status: '', // ステータス
  acceptance_or_disapproval: '0', // 事前審査諾否
};

//案件履歴 検索パラメータの初期値
export const reception_history_search_params_init = {
  from_update_at: '',
  to_update_at: '',
  update_user_type: new Array<KeyValue>(),
  update_name: '',
  status: '',
  item_name: '',
  item_old_value: '',
  item_new_value: '',
};

//ログ一覧 検索パラメータの初期値
export const log_search_params_init = {
  created_at_from_ymd: '',
  created_at_from_hour: '',
  created_at_from_minute: '',
  created_at_to_ymd: '',
  created_at_to_hour: '',
  created_at_to_minute: '',
  error_level: '',
  message_code: '',
  message: '',
  reception_cd: '',
  reception_sub_cd: '',
  operation: '',
  src_address: '',
};

// 営業日カレンダーの設定
export const business_day_calendar = {
  min_date: -36500, // 選択可能な日付の最低日数
  max_year: 100, // 選択可能な日付の最大年数
};

// DatepickerJpの設定
export const datepicker_jp = {
  year_from: 11, // N年後の未来年を表示する
  year_to: 101, // N年前の過去年を表示する
};

// マスク文字列
export const mask_string = '●';

//ローディング画面非表示時のタイマー設定
export const loding_close_timmer = 5000;

//案件履歴画面ヘッダー初期値
export const header_info_init = {
  application_product: '',
  is_history: true,
  is_staff: true,
  reception_cd: '',
  status_code: 0,
  status_name: '',
  user_name: '',
};
// 時コントロール選択項目
export const hours = [
  '00',
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
];

// 分コントロール選択項目
export const minutes = [
  '00',
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
  '31',
  '32',
  '33',
  '34',
  '35',
  '36',
  '37',
  '38',
  '39',
  '40',
  '41',
  '42',
  '43',
  '44',
  '45',
  '46',
  '47',
  '48',
  '49',
  '50',
  '51',
  '52',
  '53',
  '54',
  '55',
  '56',
  '57',
  '58',
  '59',
];

// ポップアップ内容
export const popup_content = {
  title: '',
  sub_title: '',
  text: '',
};

// 詳細画面の「マイページへ戻る」ボタンが「戻る」ボタンになるときのステータスコード
// TODO takaama 下記は仮の値、随時変更すること
export const back_button_code = [2000, 3000, 4000];

// 都道府県
export const prefectures = {
  '01': '北海道',
  '02': '青森県',
  '03': '岩手県',
  '04': '宮城県',
  '05': '秋田県',
  '06': '山形県',
  '07': '福島県',
  '08': '茨城県',
  '09': '栃木県',
  '10': '群馬県',
  '11': '埼玉県',
  '12': '千葉県',
  '13': '東京都',
  '14': '神奈川県',
  '15': '新潟県',
  '16': '富山県',
  '17': '石川県',
  '18': '福井県',
  '19': '山梨県',
  '20': '長野県',
  '21': '岐阜県',
  '22': '静岡県',
  '23': '愛知県',
  '24': '三重県',
  '25': '滋賀県',
  '26': '京都府',
  '27': '大阪府',
  '28': '兵庫県',
  '29': '奈良県',
  '30': '和歌山県',
  '31': '鳥取県',
  '32': '島根県',
  '33': '岡山県',
  '34': '広島県',
  '35': '山口県',
  '36': '徳島県',
  '37': '香川県',
  '38': '愛媛県',
  '39': '高知県',
  '40': '福岡県',
  '41': '佐賀県',
  '42': '長崎県',
  '43': '熊本県',
  '44': '大分県',
  '45': '宮崎県',
  '46': '鹿児島県',
  '47': '沖縄県',
};

// 利用形態
export const usage_pattern_type = {
  normal: '0',
  from_preliminary_review: '1',
};

// MDBDatatableのconfig
export const mdbdatatable_config = {
  info_label: {
    init: ['', '～', '件目を表示 (全', '件)'],
    zero_rows: ['', '～', '件目を表示 (全', '件'], // 0行時の件数表示
  },
};

// 同意文タイプ
export const clause_type = {
  mypage: 1,
  personal_info: 2,
  antisocial: 3,
};

// 口座情報アコーディオンのJA金融機関コード
export const bank_cd_column = 'receptions.bank_cd';
// 取引希望店アコーディオンのJA金融機関コード
export const bank_cd_tmp_column = 'receptions.bank_cd_tmp';

// 口座情報アコーディオンの取引店のカラム名
export const bank_branch_name_column = 'receptions.bank_branch_name';
// 取引希望店アコーディオンの取引店のカラム名
export const desired_bank_branch_name_column = 'receptions.desired_bank_branch_name';

// 口座情報アコーディオンの取引店コードのカラム名
export const bank_branch_cd_column = 'receptions.bank_branch_cd';
// 取引希望店アコーディオンの取引店コードのカラム名
export const desired_bank_branch_cd_column = 'receptions.desired_bank_branch_cd';

// 口座情報アコーディオンのJA名のfm_id
export const account_info_janame_fm_id = [1030];
// 取引希望店アコーディオンのJA名のfm_id
export const shop_where_one_wishes_business_janame_column = [3910];

// 数字記号
export const number_symbol: { [key: number]: string } = {
  0: '①',
  1: '②',
  2: '③',
  3: '④',
  4: '⑤',
  5: '⑥',
  6: '⑦',
  7: '⑧',
  8: '⑨',
  9: '⑩',
  10: '⑪',
  11: '⑫',
  12: '⑬',
  13: '⑭',
  14: '⑮',
  15: '⑯',
  16: '⑰',
  17: '⑱',
  18: '⑲',
  19: '⑳',
};

// ローン種類選択画面に表示する情報
export const loan_info = [
  {
    name: '住宅ローン(かんたん審査)',
    text: '新築・増改築、建売住宅やマンションの購入などでご利用いただけるローンです。',
    type: 'house',
    loan_type_cd: '01',
    is_new_line: false,
  },
  {
    name: `住宅ローン(借換)\n  (かんたん審査)`,
    text: '他金融機関等でお借入中の住宅ローンを借り換える場合にご利用いただけるローンです。',
    type: 'house',
    loan_type_cd: '02',
    is_new_line: true,
  },
  {
    name: 'マイカーローン',
    text: '新車や中古車の購入をはじめ、修理・車検費用などにご利用いただけるローンです。',
    type: 'mycar',
    loan_type_cd: '04',
    is_new_line: false,
  },
  {
    name: '教育ローン(一般)',
    text: '入学金や授業料など幅広い教育資金でご利用いただけるローンです。',
    type: 'study',
    loan_type_cd: '06',
    is_new_line: false,
  },
  {
    name: '教育ローン(カード)',
    text:
      '入学金や授業料など幅広い教育資金に対して、借入枠の範囲で何度もご利用いただけるローンです。',
    type: 'study',
    loan_type_cd: '07',
    is_new_line: false,
  },
  {
    name: 'リフォームローン',
    text: '住宅の増改築・改装などリフォームでご利用いただけるローンです。',
    type: 'reform',
    loan_type_cd: '08',
    is_new_line: false,
  },
  {
    name: '多目的ローン',
    text:
      'お使い道が決まっていれば、様々な用途にご利用いただけるローンです。(資金使途証明書類が必要です)',
    type: 'multi',
    loan_type_cd: '09',
    is_new_line: false,
  },
  {
    name: 'フリーローン',
    text: '様々な用途に自由にご利用いただけるローンです。(資金使途証明書類は原則不要です)',
    type: 'free',
    loan_type_cd: '10',
    is_new_line: false,
  },
  {
    name: 'カードローン',
    text: '借入枠の範囲で何度でもご利用いただけるローンです。',
    type: 'card',
    loan_type_cd: '11',
    is_new_line: false,
  },
  {
    name: 'カードローン(住宅利用者)',
    text:
      '借入枠の範囲で何度でもご利用いただけるローンです。(住宅ローン利用者限定でご利用いただけます)',
    type: 'card',
    loan_type_cd: '12',
    is_new_line: false,
  },
  {
    name: '住宅ローン(しっかり審査)',
    text:
      '新築・増改築、建売住宅やマンションの購入などでご利用いただけるローンです。より詳細な項目を入力いただくことにより、精度の高い審査が可能です。',
    type: 'house',
    loan_type_cd: '13',
    is_new_line: false,
  },
  {
    name: '住宅ローン(借換)\n  (しっかり審査)',
    text:
      '他金融機関等でお借入中の住宅ローンを借り換える場合にご利用いただけるローンです。より詳細な項目を入力いただくことにより、精度の高い審査が可能です。',
    type: 'house',
    loan_type_cd: '14',
    is_new_line: true,
  },
];

// 名前の分割記号
export const name_splitter = '　';

// 増額月のリスト
export const increase_months_list = [
  {
    name: '1月',
    value: '1',
  },
  {
    name: '2月',
    value: '2',
  },
  {
    name: '3月',
    value: '3',
  },
  {
    name: '4月',
    value: '4',
  },
  {
    name: '5月',
    value: '5',
  },
  {
    name: '6月',
    value: '6',
  },
  {
    name: '7月',
    value: '7',
  },
  {
    name: '8月',
    value: '8',
  },
  {
    name: '9月',
    value: '9',
  },
  {
    name: '10月',
    value: '10',
  },
  {
    name: '11月',
    value: '11',
  },
  {
    name: '12月',
    value: '12',
  },
];

// 時分の分割記号
export const time_splitter = ':';
// 外部リンク先設定
export const link_setting = {
  repayment_simulation: {
    name: 'ご返済額シミュレーションへ',
    anchor_housing: 'https://www.jabank.org/money/myhome.html',
    anchor_car: 'https://www.jabank.org/money/kakusyuloan/?mycar',
  },
  input_assistance_name: {
    repayment_simulation_housing: 'repayment_simulation_housing',
    repayment_simulation_car: 'repayment_simulation_car',
  },
};

// PINコード送付方法の種別
export const pin_code_send_type = {
  mail: '1', // メール
  sms: '2', // sms
  post: '3', // 本人限定郵便
};
// マイページURLの設定
export const mypage_url = `${location.origin}${process.env.MIX_MOCK_URL}/mypage/list`;
export const staff_mypage_url = `${location.origin}${process.env.MIX_MOCK_URL}/staff/menu`;

// 職員メンテナンス画面の各管理画面番号
export const maintenance_type = {
  mail_templates: 1, // メールテンプレート管理
  clauses: 2, // 同意文言管理
  displayed_documents: 3, // 掲載書類管理
  corporate: 4, // 法人
};

// メールテンプレート種別
export const mail_template_type = {
  1: 'マイページ開設案内',
  2: '借入相談受付',
  3: '借入相談入力変更依頼',
  4: '借入相談結果通知',
  5: '事前審査受付',
  6: '事前審査結果通知',
  7: '事前審査開始認証コードのご案内',
  8: '借入申込受付',
  9: 'マイページ開設招待',
  10: '借入申込同意通知',
  11: '借入申込不承認通知',
  12: '本審査結果通知',
  13: '契約書確認依頼(借入申込人)',
  14: '契約書確認依頼(連帯債務者等)',
  15: '署名完了通知',
  16: '契約辞退通知',
  17: '借入申込入力変更依頼',
  18: 'パスワードリセット',
  19: '手続き開始案内',
  20: 'ワンタイムパスワード通知',
  21: 'PINコード通知(メール)',
  22: '契約完了通知(借入申込人)',
  23: '契約完了通知(連帯債務者等)',
  24: '法人ID付与',
  25: '法人情報変更通知',
  26: '法人ユーザ追加通知',
  27: '法人ユーザ削除通知',
  28: '法人ユーザ変更通知',
  29: 'メールアドレス変更通知',
  30: 'WEB切替キャンセル通知',
  31: '借入申込希望書兼経営改善資金計画書申込結果通知',
  32: '住宅ローンしっかり審査事前審査申込変更依頼',
};

// 同意文言種別（JA、信連）
export const clause_type_list = {
  2: 'お借入の申込、保証委託の申込ならびに個人情報の取扱いに関する同意文書',
  3: '反社会的勢力ではないことの表明・確約に関する同意文書',
};

// 同意文言種別（農林中央金庫）
export const clause_type_list_nourin = {
  1: 'マイページ開設同意確認',
};

//掲載書類の種別
// TODO 値は仮
export const displayed_document_type = [
  { key: 1, value: 'マイページ掲載書類➀' },
  { key: 2, value: 'マイページ掲載書類➁' },
  { key: 3, value: 'マイページ掲載書類➂' },
  { key: 4, value: 'マイページ掲載書類⓸' },
  { key: 5, value: 'マイページ掲載書類⓹' },
];

// ローン種類css
export const loan_type_css = {
  agriculture: '-agriculture',
};

// 契約方式
export const contract_type = {
  econtract: '1', // 電子契約
  written_contract: '2', // 書面契約
};

// 案件一覧（マイページ）で表示するステータス
export const reception_status = {
  borrowing_consultation: '借入相談入力',
  borrowing_consultation_in_process: '借入相談手続中',
  borrowing_consultation_complete: '借入相談完了',
  borrowing_consultation_change: '借入相談変更中',
  borrowing_consultation_checking: '借入相談他申込者確認中',
  borrowing_consultation_disagreed: '借入相談他申込者による不同意登録済',
  pre_examination: '新規事前審査申込中',
  pre_examination_review_change: '事前審査変更中',
  pre_examination_review_checking: '事前審査他申込者確認中',
  pre_examination_review_disagreed: '事前審査他申込者による不同意登録済',
  pre_examination_in_process: '事前審査手続中',
  pre_examination_complete: '事前審査完了',
  pre_examination_withdrawal: '事前審査取下げ済',
  borrowing_application: '新規借入申込中',
  borrowing_application_check: '他申込者確認中',
  borrowing_application_disagreement: '他申込者による不同意登録済',
  borrowing_application_in_process: '借入申込手続中',
  borrowing_application_withdrawal: '借入申込取下げ済',
  borrowing_application_review_complete: '借入申込審査完了',
  borrowing_application_change: '借入申込変更中',
  contract_ready: '契約準備中',
  contract_application_withdrawal: '契約申込取下げ済',
  contract_document_ready: '契約準備完了',
  contract_conclusion: '契約締結中',
  contract_conclusion_in_process: '契約手続中',
  contract_withdrawal: '契約取下げ済',
  signagure_complete: '署名完了',
  contract_complete: '契約完了',
  modernization_funds_change: '近代化資金借入申込書変更中',
  business_improvement_financing_plan_change: '借入申込希望書兼経営改善資金計画書変更中',
};

// ステップナビゲーション初期値
export const step_init = {
  step1: '',
  step2: '',
  step3: '',
  step4: '',
  current: 0,
  show: false,
};

// 同意文の初期状態
export const agreements_init = {
  guarantor: '',
  title: '',
  text: '',
};

// パートナー上限人数
// Note：sakuma マスタの設定に合わせて1からスタート。マスタに合わせて変更する
export const guarantors_limit = {
  first: 1,
  second: 2,
  three: 3,
  fourth: 4,
  five: 5,
  six: 6,
  seven: 7,
  eight: 8,
  nine: 9,
  ten: 10,
  eleven: 11,
  twelve: 12,
  thirteen: 13,
  fourteen: 14,
  fifteen: 15,
  sixteen: 16,
  seventeen: 17,
  eighteen: 18,
  nineteen: 19,
  twenty: 20,
};

// 連帯債務者等表示初期値
export const guarantor_init = {
  guarantor_1: true,
  guarantor_2: true,
  guarantor_3: true,
  guarantor_4: true,
  guarantor_5: true,
  guarantor_6: true,
  guarantor_7: true,
  guarantor_8: true,
  guarantor_9: true,
  guarantor_10: true,
  guarantor_11: true,
  guarantor_12: true,
  guarantor_13: true,
  guarantor_14: true,
  guarantor_15: true,
  guarantor_16: true,
  guarantor_17: true,
  guarantor_18: true,
  guarantor_19: true,
  guarantor_20: true,
  is_guarantor: false,
  is_signed: false,
};

/**
 * 対応する郵便番号のindex値
 * first：array[0]
 * last：array[1]
 */
export const postcode_index = {
  first: 0,
  last: 1,
};

/**
 * 郵便番号のフォーマット指定
 * hyphen ppostする際のフォーマット記号
 * placeholder プレースホルダの分割記号
 */
export const postcode_splitter = {
  hyphen: '-',
  placeholder: ' ',
};

// 月のコレクション
export const months = [
  '1月',
  '2月',
  '3月',
  '4月',
  '5月',
  '6月',
  '7月',
  '8月',
  '9月',
  '10月',
  '11月',
  '12月',
];

//借換対象のチェックボックスがチェックされていない場合の値
export const refinance_target_check_off = '0';

export const contract_info_int = {
  loan_scheduled_date: '',
  planned_borrowing_amount: '',
  desired_econtract: '',
};

// ステータスコードの一覧
export const status_code_list = {
  modernization_funds_borrowing_application: 1000,
  borrowing_consultation_updating: 1200, // 借入相談変更中
  borrowing_consultation_checking: 1250, // 借入相談保証人確認中
  borrowing_consultation_disagreed: 1260, // 借入相談保証人不同意
  borrowing_consultation_result_ng: 91550, // 借入相談結果登録済（不承認）
  borrowing_consultation_result_approval: 1500,
  pre_examination1: 1600, // 新規事前審査申込
  preliminary_review_updating: 1710, //事前審査変更中
  preliminary_review_checking: 1750, // 事前審査保証人確認中
  preliminary_review_disagreed: 1760, // 事前審査保証人不同意
  pre_examination_result_approval: 2000,
  borrowing_application: 2100,
  borrowing_application_change: 2200,
  borrowing_application_input: 2300,
  borrowing_application_waiting_mp: 2310,
  borrowing_application_linked_mp: 2330,
  borrowing_application_check: 2400,
  borrowing_application_disagreement: 2500,
  borrowing_application_wait: 2600,
  borrowing_application_waiting_mdn: 2610,
  borrowing_application_doing_mdn: 2910,
  borrowing_application_withdrawal_wait: 2700,
  borrowing_application_result_approval: 3000,
  contract_application_wait: 3100,
  contract_document_register1: 3500,
  contract_document_register2: 3600,
  contract_conclusion: 3700,
  contract_conclusion_wait: 3800,
  contract_withdrawal_wait: 3900,
};

// HTTPステータスコード
export const http_status_code_list = {
  unauthorized: 401,
};

// Network Errorメッセージ
export const network_error_message = 'Network Error';

// keyCodeの一覧
export const key_code_list = {
  space: 32,
};

// ローン種類
export const loan_types = {
  housing_loan_firmly: '13', // 住宅ローン_しっかり審査
  housing_loan_firmly_refinancing: '14', // 住宅ローン_しっかり審査（借換）
  modernization_funds_main: '31', // 近代化資金メイン
  business_improvement_financing_plan: '32', // 借入申込希望書兼経営改善資金計画書
  modernization_funds: '33', // 近代化資金
};

// 近代化資金借入申込完了・借入申込希望書兼経営改善資金計画書完了で使用するパターンの値
export const modernization_funds_complete_disp_type = {
  pattern_1: '1',
  pattern_2: '2',
  change_borrowing_application: '3',
  pattern_4: '4',
};

// 借入希望書兼経営改善資金計画書フラグの値
export const mp_flg = {
  none: 0, //未設定
  input: 1, // 入力中
  change: 2, // 変更中
  completion: 3, // 入力・変更完了
  loan_approval_has_been_coordinated: 4, //融資稟議連携済
};

// 近代化資金借入申込書フラグの値
export const ma_flg = {
  none: 0, //未設定
  input: 1, // 入力中
  change: 2, // 変更中
  completion: 3, // 入力・変更完了
  loan_approval_has_been_coordinated: 4, //融資稟議連携済
};

// 申込区分と紐づく申込人のユーザロール
export const mp_ap_section_to_user_role = {
  personal: '1', // 個人
  corporation: '4', // 法人
};

// 申込区分の値
export const modernization_funds_application_category = {
  personal: '1', // 個人
  corporation: '2', //  法人/団体
};

// オンライン本人確認の値
export const online_identification = {
  implementation: '0', // 実施する
  not_implementation: '1', // 実施しない
  implementationted: '2', //実施済み
};

// DateオブジェクトをLocale変換して出力する時のタイムゾーン設定
export const tz_config = {
  // 日本標準時
  jst: {
    lang: 'ja-JP',
    timezone: { timeZone: 'Asia/Tokyo' },
  },
  // イギリス標準時
  gmt: {
    lang: 'en-gb',
    timezone: { timeZone: 'Europe/London' },
  },
};

//お引希望店舗と口座情報での出し分けを行う値
export const office_type = {
  desired_trading: '1', //お取引希望店舗の取引店
  account_infomation: '2', //口座情報の取引店
  common: '3', //お取引希望店舗と口座情報の取引店
};
